import {
  NotificationsRequestsDocument,
  NotificationsRequestsQuery,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useNotificationsRequests = () => {
  const { client, data, loading } = useQuery(NotificationsRequestsDocument, {
    variables: {
      companyId: useCurrentSession().company.id,
    },
  })

  // Remove the request with the passed 'id' from the list if
  // the passed 'id' is found
  const removeRequestById = (id: string) => {
    client.cache.evict({
      id: client.cache.identify({ id: id, __typename: 'NotificationsRequest' }),
    })
  }

  const requests = data?.notifications?.requests ?? []

  return {
    requests,
    loading,
    removeRequestById,
  }
}

export type InboxRequest = NotificationsRequestsQuery['notifications']['requests'][number]
